export default store => {
  store.on("@init", () => ({
    favorites: {
      note: null
    }
  }));
  store.on("@change.favorites", (state, data) => ({ favorites: { ...state.favorites, ...data } }));
};
